__turbopack_context__.v({
  "cell": "Summary-module__DyYOkq__cell",
  "closeModalButton": "Summary-module__DyYOkq__closeModalButton",
  "codonationAmountSumCell": "Summary-module__DyYOkq__codonationAmountSumCell",
  "codonationAmountSumContent": "Summary-module__DyYOkq__codonationAmountSumContent",
  "codonationSelectionCell": "Summary-module__DyYOkq__codonationSelectionCell",
  "donationSummaryContainer": "Summary-module__DyYOkq__donationSummaryContainer",
  "explanationMoreInfoButton": "Summary-module__DyYOkq__explanationMoreInfoButton",
  "row": "Summary-module__DyYOkq__row",
  "table": "Summary-module__DyYOkq__table",
  "totalDonationAmountSumCell": "Summary-module__DyYOkq__totalDonationAmountSumCell",
  "totalDonationAmountSumContent": "Summary-module__DyYOkq__totalDonationAmountSumContent",
});
